import confirmSoundFile from '@/assets/sounds/confirm.mp3'
import bellSoundFile from '@/assets/sounds/alert.wav'
import { useSound } from '@vueuse/sound'
import { ref, type Ref } from 'vue'
import { isNull } from 'lodash'

export const useConfirmationsTimer = (maxConfirms: Ref<number>) => {
  let timer = 0
  const counter = ref(0)
  const confirmSound = useSound(confirmSoundFile)
  const bellSound = useSound(bellSoundFile)

  const stopTimer = () => {
    if (!timer) {
      return
    }
    clearInterval(timer)
    timer = 0
    counter.value = 0
  }

  const handleSpreadWatch = (
    v: number,
    onSpreadTriggered: () => void,
    triggerValue: Ref<number>,
    triggerConfirmations: Ref<boolean>,
  ) => {
    if (isNull(triggerValue.value) || isNull(v)) {
      return
    }
    if (v >= triggerValue.value) {
      if (!triggerConfirmations.value) {
        onSpreadTriggered()
      } else {
        confirmSound.play()
        startTimerOnce(onSpreadTriggered)
      }
    } else {
      stopTimer()
    }
  }

  const startTimerOnce = (onReach: () => void, timeout: number = 1000) => {
    if (timer) {
      return
    }
    timer = window.setInterval(() => {
      if (counter.value >= maxConfirms.value - 1) {
        onReach()
        stopTimer()
        bellSound.play()
        return
      }
      confirmSound.play()
      counter.value += 1
    }, timeout)
  }

  return {
    startTimerOnce,
    handleSpreadWatch,
    stopTimer,
  }
}
